export interface Version {
  id: number;
  genericId: number;
  reason: Reason;
  status: VersionStatus;
  liveDate: string;
  hasEmbedded: boolean;
  nestedCounterList: boolean;
  hideToc: boolean;
  contents: VersionContent[];
}

export enum Reason {
  UpdatedByUser = 'Updated by user',
  UpdatedByGeneric = 'Generic update',
}

export enum VersionStatus {
  draft = 'draft',
  scheduled = 'scheduled',
  published = 'published',
}

export interface VersionContent {
  language: string;
  html: string;
  name?: string;
}
